import { Events } from 'global/constants';
import orderHistoryAddProductsCollectData from 'account/orderHistory/orderHistoryAddProducts/orderHistoryAddProductsCollectData';

const { events } = window.od;

class OrderHistoryAddToListBtn {
	constructor(validator) {
		const addToListBtn = document.querySelector('[data-id="addToListBtn"]');
		if (addToListBtn) {
			this.validator = validator;
			addToListBtn.addEventListener(
				'click',
				this.handleAddToListBtn.bind(this),
			);
		}
	}

	handleAddToListBtn() {
		const products = document.querySelectorAll(
			'[data-product-row-add-product]',
		);
		const addProductsData = orderHistoryAddProductsCollectData(products);
		if (this.validator.validateForm(addProductsData)) {
			events.publish(Events.ADD_TO_LIST_BTN_CLICK_END);
		}
	}
}

export default OrderHistoryAddToListBtn;
